export default {"src":"/customer-services/_next/static/media/logo-wishlist.ccb94151.svg","height":24,"width":139,"blurWidth":0,"blurHeight":0};